export const handleEditAction = (id, pushModal, i18n, reload, isDuplicateMode = false) => {
    return pushModal({
        title: isDuplicateMode
            ? `${i18n`Duplicate`} ${i18n`Translations_Table`}`
            : i18n`Edit Translation Table` + ` ${id}`,
        view: `TranslationTableForm`,
        args: { id, isDuplicateMode },
    })
        .then(() => {
            reload && reload();
        })
        .catch(() => null);
};
